import Image from 'next/image';
import { FC } from 'react';

import IconWrapper from './IconWrapper';
import Label from './Label';
import Wrapper from './Wrapper';

export type FeatureProps = {
  icon: string;
  name: string;
  value: string;
};

const Feature: FC<FeatureProps> = ({ icon, name, value }) => {
  return (
    <Wrapper>
      <IconWrapper>
        <Image
          alt={name}
          src={icon}
          width={20}
          height={20}
        />
      </IconWrapper>
      <Label>{name}:</Label> {value}
    </Wrapper>
  );
};

export default Feature;
